import { render } from "./IssueMain.view.vue?vue&type=template&id=47dd48a8&scoped=true&ts=true"
import script from "./IssueMain.view.vue?vue&type=script&lang=ts"
export * from "./IssueMain.view.vue?vue&type=script&lang=ts"

import "./IssueMain.view.vue?vue&type=style&index=0&id=47dd48a8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47dd48a8"]])

export default __exports__